
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-tmsclient_connection",
  "use": "icon-rescls-tmsclient_connection-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-rescls-tmsclient_connection\"><path fill=\"#b3b9ba\" d=\"M2.884 5a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1m4.5 0a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1\" /><path fill=\"#ccdae5\" d=\"M16 11h-3V8h2c.55 0 1 .45 1 1z\" /><path fill=\"#106a90\" d=\"M8 11V9c0-.55.45-1 1-1h2v3z\" /><path fill=\"#ccdae5\" d=\"M11 16v-3H8v2c0 .55.45 1 1 1z\" /><path fill=\"#106a90\" d=\"M16 15v-2h-3v3h2c.55 0 1-.45 1-1\" /><path fill=\"#b3b9ba\" d=\"M6.5 12.5A.5.5 0 0 1 6 12V9.5H4V12c0 1.378 1.122 2.5 2.5 2.5z\" /><path fill=\"#ffca28\" d=\"M6.5 9c0-1.379 1.121-2.5 2.5-2.5v-1a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2v1.862C1 9.638 2.8 11.5 5 11.5c.53 0 1.036-.11 1.5-.306z\" /><path fill=\"#fff\" d=\"M16 11h-3V8h-2v3H8v2h3v3h2v-3h3z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-tmsclient_connection"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-tmsclient_connection";

        export default Icon;
    